import { render, staticRenderFns } from "./PricePointGroups.vue?vue&type=template&id=7f98f662"
import script from "./PricePointGroups.vue?vue&type=script&lang=js"
export * from "./PricePointGroups.vue?vue&type=script&lang=js"
import style0 from "./PricePointGroups.vue?vue&type=style&index=0&id=7f98f662&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports